<template>
<div style="clear:both;">
    <!-- <fieldset v-if="debug">
        <legend>WIDGET - MANAGER QID: {{question.config.id}}</legend>
        <ul>
            <li>Survey Reference: {{survey_reference}}</li>
            <li>Survey has widgets: {{exists}}</li>
        </ul>
        <component v-if="exists" 
            :key="survey_reference+'_'+question.config.id" 
            :is="survey_reference"
            :question="question"
            :questionMap="questionMap"
            :survey="survey"
            :widgetRules="widgetRules"
            :debug="debug"
            @log="log"
        />
    </fieldset> -->

    <component v-if="exists" 
        :key="survey_reference+'_'+question.config.id" 
        :is="survey_reference"
        :question="question"
        :questionMap="questionMap"
        :survey="survey"
        :widgetRules="widgetRules"
        :debug="debug"
        @log="log"
        @widgetRequest="widgetRequest"
    />  
</div>
</template>

<script>
//Add widgets by survey reference key here - loader should import individual widgets
const surveyWidgets = {
    'ARC-2020-patient-survey': () => import('./programs/2020 ARC/patient survey/loader'),
    'ARC-2020-case-1': () => import('./programs/2020 ARC/case 1/loader'),
    'ARC-2020-case-2': () => import('./programs/2020 ARC/case 2/loader'),
    'ARC-2020-case-3': () => import('./programs/2020 ARC/case 3/loader'),
    'AZ-PWC-2020-patient-profile': () => import('./programs/2020 PWC/patient profile/loader'),
    'AIMMF-2020-patient-assessment': () => import('./programs/2020 AIM_MF/patient assessment/loader'),
    'AIMAML-2021-patient-assessment': () => import('./programs/2021 AIM_AML/patient_assessment/loader'),
    'AIMMDS-2021-practice-profile': () => import('./programs/2021 AIM_MDS/practice_profile/loader'),
    'AIMMDS-2021-patient-assessment': () => import('./programs/2021 AIM_MDS/patient_assessment/loader'),
    'STRIVE-2021-patient-assessment': () => import('./programs/2021 STRIVE/patient_assessment/loader'),
    'ECHO-CLL-2022-practice-profile': () => import('./programs/2022 ECHO_CLL/practice_profile/loader'),
    'ECHO-CLL-2022-patient-assessment': () => import('./programs/2022 ECHO_CLL/patient_assessment/loader') 
}

export default {
    name: 'widget-manager',
    components: surveyWidgets,
    props: {
        question: {
            type: Object,
            required: true
        },
        questionMap: {
            type: Object,
            required: true
        },
        survey: {
            type: Object,
            required: true
        },
        widgetRules: {
            type: Array,
            required: true
        },
        program_reference: {
            type: String,
            required: false,
            default: null
        },
        survey_reference: {
            type: String,
            required: false,
            default: null
        },
        debug: {
            type: Boolean,
            required: false,
            default: false
        } 
    },
    created: function(){
        var component = this;
        const controller = require("./lib/controller.js").default;
        component.controller = new controller(component);
    },
    data: function(){
        return {
            controller: null,
            loaded_widgets: null,
            logTimer: null
        }
    },
    methods: {
        log: function(data){
            var self = this;
            self.$emit('log',data)
        },
        widgetRequest: function(data){
            this.$emit('widgetRequest',data);
        }
    },
    computed: {
        exists: function(){
            let result = this.$options.components[this.survey_reference] ? true : false;
            return result
        }
    }
}
</script>

<style module>

</style>